import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function Support() {
  React.useEffect(() => {
    document.title = "Soon. — Support";
  }, []);

  return (
    <motion.article 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-3xl mx-auto w-full py-8 md:py-16"
    >
      <header className="mb-16">
        <h1 className="font-serif italic text-4xl md:text-5xl text-brand-cream mb-4">Soon. Support</h1>
        <p className="font-mono uppercase tracking-[0.15em] text-sm text-brand-dim">Help with the Soon. countdown app.</p>
      </header>

      <div className="prose-custom">
        <h2>Contact us</h2>
        <p>
          For questions, bug reports, or feature requests, email <a href="mailto:sussexendocrineclinic@gmail.com">sussexendocrineclinic@gmail.com</a>. We usually reply within a couple of working days.
        </p>

        <h2>Common questions</h2>
        
        <h3>Where is my data stored?</h3>
        <p>
          Everything stays on your device. Soon. has no servers and no accounts, so your countdowns are private to your phone.
        </p>

        <h3>Why does the app ask for calendar or contacts access?</h3>
        <p>
          Only so you can pick existing events or contact birthdays to count down to. You can decline, and the rest of the app still works. Nothing is ever uploaded.
        </p>

        <h3>I am not getting reminder notifications.</h3>
        <p>
          Open your device settings, find Soon., and make sure Notifications are allowed. Notifications are scheduled locally on your device.
        </p>

        <h3>How do I delete my data?</h3>
        <p>
          Deleting the app removes all of its data from your device.
        </p>

        <h2>Privacy and terms</h2>
        <p>
          Please review our <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-of-use">Terms of Use</Link> for more detailed information.
        </p>
      </div>
    </motion.article>
  );
}